import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { NavigationHeader } from '../../../components/UploadNavHeader';

interface INavigationWrapper {
  onFileUploadClick?: () => void;
  onTemplateDownloadClick?: () => void;
  isUploadDisabled?: boolean;
  showUpload?: boolean;
  showDownloadTemplate?: boolean;
}

const ENVIRONMENT_SETUP = 'Environment setup';
const BACK_END_ACCESS = 'Back End Access';

const TABS = [ENVIRONMENT_SETUP, BACK_END_ACCESS];

const ROUTES_MAP = {
  [ENVIRONMENT_SETUP]: '/settings/environment-setup',
  [BACK_END_ACCESS]: '/settings/back-end-access',
};

export const NavigationWrapper: React.FC<INavigationWrapper> = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedTab, setSelectedTab] = useState<string>(
    Object.keys(ROUTES_MAP).find(
      (tabName) =>
        ROUTES_MAP[tabName as keyof typeof ROUTES_MAP] === location.pathname
    ) || ENVIRONMENT_SETUP
  );

  const handleOnTabClick = (tab: string) => {
    if (selectedTab !== tab) {
      setSelectedTab(tab);
      navigate(ROUTES_MAP[tab as keyof typeof ROUTES_MAP]);
    }
  };

  return (
    <NavigationHeader
      tabs={TABS}
      selectedTab={selectedTab}
      onTabClick={handleOnTabClick}
    />
  );
};
